export default {
  // Navigation
  nav_dashboard: "Tableau de bord",
  nav_alerts: "Alertes",
  nav_predictions: "Prédictions",
  nav_resources: "Ressources",
  nav_organizations: "Organisations",
  nav_settings: "Paramètres",
  nav_reports: "Rapports",
  nav_home: "Accueil",
  nav_login: "Se connecter",
  nav_signup: "Demander l'accès",
  nav_logout: "Se déconnecter",

  // Auth
  auth_welcome_back: "Bon retour",
  auth_sign_in: "Se connecter",
  auth_email: "Adresse e-mail",
  auth_password: "Mot de passe",
  auth_forgot_password: "Mot de passe oublié ?",
  auth_remember_me: "Rester connecté pendant 30 jours",
  auth_quick_login: "Connexion rapide en tant qu'utilisateur de démo",
  auth_no_account: "Demander l'accès",
  auth_back_home: "Retour à l'accueil",
  auth_invalid_credentials: "Identifiants invalides. Tous les comptes de démo utilisent le mot de passe : demo",
  auth_password_hint: "Mot de passe de démo pour tous les comptes :",
  auth_reset_password: "Réinitialiser le mot de passe",
  auth_send_reset: "Envoyer le lien de réinitialisation",
  auth_check_email: "Vérifiez votre e-mail",
  auth_reset_sent: "Si un compte existe pour {{email}}, vous recevrez bientôt un lien de réinitialisation.",
  auth_back_to_signin: "Retour à la connexion",
  auth_sending: "Envoi en cours...",
  auth_signing_in: "Connexion en cours...",

  // Landing
  landing_hero_title: "Prédire les épidémies de paludisme",
  landing_hero_subtitle: "Avant qu'elles ne surviennent",
  landing_hero_desc: "MalariaGuard donne aux ministères de santé africains et aux organisations une intelligence prédictive pour déployer des ressources de manière proactive, sauver des vies et briser le cycle de transmission.",
  landing_access_dashboard: "Accéder au tableau de bord",
  landing_explore_features: "Explorer les fonctionnalités",
  landing_features_title: "Conçu pour les premières lignes",
  landing_features_subtitle: "Chaque fonctionnalité a été conçue avec la contribution d'épidémiologistes, d'agents de santé et de travailleurs de terrain au Cameroun et au-delà.",
  landing_tech_title: "Comment fonctionne EpiSense AI",
  landing_tech_subtitle: "Un aperçu transparent du pipeline d'apprentissage automatique qui alimente chaque prédiction.",
  landing_testimonials_title: "Approuvé par les équipes de terrain",
  landing_testimonials_subtitle: "Témoignages d'épidémiologistes, de coordonnateurs et de directeurs utilisant MalariaGuard chaque jour.",
  landing_pricing_title: "Tarification simple et transparente",
  landing_pricing_subtitle: "Choisissez le plan adapté à votre équipe. Sans frais cachés. Annulation à tout moment.",
  landing_cta_title: "Prêt à transformer la riposte au paludisme ?",
  landing_cta_desc: "Rejoignez les ministères de santé et les organisations qui utilisent déjà MalariaGuard pour prédire, préparer et prévenir les épidémies de paludisme en Afrique.",
  landing_get_started: "Commencer maintenant",
  landing_request_access: "Demander l'accès",

  // Dashboard
  dash_title: "Tableau de bord",
  dash_subtitle: "Surveillance des épidémies de paludisme en temps réel et aperçu des prédictions IA",
  dash_predicted_cases: "Cas prévus (2 sem)",
  dash_growth_rate: "Taux de croissance",
  dash_high_alert: "Districts à haut risque",
  dash_active_interventions: "Interventions actives",
  dash_vs_last: "vs. période précédente",
  dash_new_this_week: "nouveau cette semaine",
  dash_district_map: "Carte des risques par district",
  dash_cameroon_20: "Cameroun — 20 districts surveillés",
  dash_national_trend: "Tendance nationale des cas",
  dash_weekly_confirmed: "Cas confirmés hebdomadaires, tous districts",
  dash_activity_feed: "Flux d'activité en direct",
  dash_realtime_events: "Événements de la plateforme en temps réel",
  dash_quick_alerts: "Alertes rapides",
  dash_weather_snapshot: "Aperçu météo",
  dash_temp_rain: "Température et pluie — 7 derniers jours",
  dash_district_summary: "Résumé des districts",
  dash_total_districts: "Total des districts",
  dash_pop_covered: "Population couverte",
  dash_high_risk: "Haut risque",
  dash_medium_risk: "Risque moyen",
  dash_low_risk: "Faible risque",
  dash_district_leaderboard: "Classement des districts",
  dash_top_5_growth: "Top 5 par taux de croissance prévu",
  dash_view_all: "Voir tout",
  dash_last_7_days: "7 derniers jours",
  dash_refresh_data: "Actualiser les données",
  dash_online: "En ligne",
  dash_last_sync: "Dernière synchro : il y a 3 min",

  // Alerts
  alerts_title: "Alertes",
  alerts_subtitle: "Alertes d'épidémie classées par IA avec actions recommandées",
  alerts_filters: "Filtres",
  alerts_export_csv: "Exporter CSV",
  alerts_region: "Région",
  alerts_severity: "Gravité",
  alerts_status: "Statut",
  alerts_date_from: "Date de début",
  alerts_date_to: "Date de fin",
  alerts_search: "Rechercher par district, ID d'alerte ou action...",
  alerts_all_regions: "Toutes les régions",
  alerts_all_severities: "Toutes les gravités",
  alerts_all_statuses: "Tous les statuts",
  alerts_ai_reasoning: "Raisonnement IA",
  alerts_contributing_factors: "Facteurs contributifs",
  alerts_active_interventions: "Interventions actives",
  alerts_no_match: "Aucune alerte ne correspond à vos filtres",
  alerts_showing: "Affichage de {{count}} sur {{total}} alertes",

  // Predictions
  pred_title: "Prédictions",
  pred_subtitle: "Prédictions ML XGBoost avec bandes de confiance et importance des caractéristiques",
  pred_overview: "Aperçu des prédictions",
  pred_features: "Importance des caractéristiques",
  pred_predicted_cases: "Cas prévus",
  pred_confidence: "Score de confiance",
  pred_alert_level: "Niveau d'alerte",
  pred_confidence_range: "Intervalle de confiance",
  pred_ci_desc: "Intervalle de confiance à 95% pour le nombre de cas prévus",
  pred_model_info: "Infos du modèle",
  pred_algorithm: "Algorithme",
  pred_input_features: "Caractéristiques d'entrée",
  pred_training_data: "Données d'entraînement",
  pred_retrain: "Fréquence de réentraînement",
  pred_last_trained: "Dernier entraînement",
  pred_model_version: "Version du modèle",
  pred_pipeline_healthy: "Pipeline opérationnel",
  pred_top_drivers: "Top 5 facteurs d'épidémie",
  pred_drivers_desc: "Scores d'importance des caractéristiques du modèle XGBoost",

  // Resources
  res_title: "Ressources",
  res_subtitle: "Gestion des stocks avec alertes de rupture et prévision de la demande",
  res_add_resource: "Ajouter une ressource",
  res_export_csv: "Exporter CSV",
  res_total_items: "Total des articles",
  res_low_stock: "Stock faible",
  res_total_gap: "Écart total",
  res_orgs: "Organisations",
  res_search: "Rechercher des ressources...",
  res_all_districts: "Tous les districts",
  res_all_orgs: "Toutes les organisations",
  res_low_stock_only: "Stock faible uniquement",
  res_resource: "Ressource",
  res_type: "Type",
  res_quantity: "Quantité",
  res_district: "District",
  res_organization: "Organisation",
  res_demand_gap: "Écart de demande",
  res_updated: "Mis à jour",
  res_sufficient: "Suffisant",
  res_below_threshold: "Sous le seuil",

  // Organizations
  org_title: "Organisations",
  org_subtitle: "Organisations partenaires, utilisateurs actifs et métriques d'engagement",

  // Settings
  settings_title: "Paramètres",
  settings_subtitle: "Seuils d'alerte, gestion des utilisateurs, clés API et santé du système",
  settings_your_role: "Votre rôle :",
  settings_thresholds: "Seuils d'alerte",
  settings_users: "Gestion des utilisateurs",
  settings_apikeys: "Clés API",
  settings_health: "Santé du système",
  settings_high_alert: "Alerte élevée",
  settings_medium_alert: "Alerte moyenne",
  settings_low_normal: "Faible / Normal",
  settings_threshold_desc: "Définissez les seuils de taux de croissance qui déterminent les niveaux de gravité des alertes dans tous les districts.",
  settings_high_desc: "Se déclenche lorsque le taux de croissance prévu dépasse cette valeur. Mobilisation complète recommandée.",
  settings_medium_desc: "Se déclenche lorsque le taux de croissance se situe entre les seuils moyen et élevé. Surveillance renforcée.",
  settings_low_desc: "Les taux de croissance inférieurs à ce seuil sont considérés comme normaux. Surveillance de routine maintenue.",
  settings_threshold_viz: "Visualisation des seuils",
  settings_save: "Enregistrer les seuils",
  settings_reset: "Réinitialiser",
  settings_all_users: "Tous les utilisateurs",
  settings_manage_keys: "Gérer les clés d'accès pour les intégrations externes",
  settings_create_key: "Créer une clé",
  settings_regenerate: "Régénérer",
  settings_revoke: "Révoquer",
  settings_overall: "État global",
  settings_avg_uptime: "Disponibilité moyenne",
  settings_avg_latency: "Latence moyenne",
  settings_last_incident: "Dernier incident",
  settings_service_health: "Santé des services",
  settings_role_sim: "Simulateur d'accès par rôle",
  settings_role_sim_desc: "Prévisualisez l'apparence de la plateforme pour différents rôles utilisateurs.",

  // Reports
  reports_title: "Rapports",
  reports_subtitle: "Résumés d'épidémie exportables et analyses comparatives par district",
  reports_outbreak_summary: "Résumé des épidémies",
  reports_district_comparison: "Comparaison des districts",
  reports_export_pdf: "Exporter PDF",
  reports_export_csv: "Exporter CSV",
  reports_date_range: "Plage de dates",
  reports_region_filter: "Région",
  reports_all_regions: "Toutes les régions",
  reports_total_districts: "Total des districts",
  reports_high_risk: "Districts à haut risque",
  reports_cases_this_week: "Cette semaine",
  reports_avg_growth: "Taux de croissance moyen",
  reports_interventions_active: "Interventions actives",
  reports_district: "District",
  reports_region: "Région",
  reports_population: "Population",
  reports_predicted_2wk: "Prévu (2 sem)",
  reports_predicted_1mo: "Prévu (1 mois)",
  reports_predicted_3mo: "Prévu (3 mois)",
  reports_growth_rate: "Taux de croissance",
  reports_alert_level: "Niveau d'alerte",
  reports_risk_trend: "Tendance de risque",
  reports_resources_gap: "Écart de ressources",
  reports_exported: "Rapport exporté avec succès",
  reports_comparing: "Comparaison de {{count}} districts",
  reports_no_data: "Aucune donnée ne correspond aux filtres sélectionnés",
  reports_weekly_trend: "Tendance hebdomadaire",
  // reports_outbreaks_prevented: "Épidémies évitées", // duplicate key removed

  reports_coverage: "Couverture",

  // Common
  common_save: "Enregistrer",
  common_cancel: "Annuler",
  common_delete: "Supprimer",
  common_edit: "Modifier",
  common_add: "Ajouter",
  common_search: "Rechercher",
  common_filter: "Filtrer",
  common_reset: "Réinitialiser",
  common_close: "Fermer",
  common_loading: "Chargement...",
  common_success: "Succès",
  common_error: "Erreur",
  common_confirm: "Confirmer",
  common_yes: "Oui",
  common_no: "Non",
  common_showing: "Affichage de",
  common_of: "sur",
  common_all: "Tout",
  common_live: "En direct",
  common_normal: "Normal",
  common_warning: "Attention",
  common_critical: "Critique",
  common_operational: "Opérationnel",
  common_degraded: "Dégradé",
  common_active: "Actif",
  common_acknowledged: "Reconnu",
  common_resolved: "Résolu",
  common_high: "Élevé",
  common_medium: "Moyen",
  common_low: "Faible",
  common_2weeks: "2 semaines",
  common_1month: "1 mois",
  common_3months: "3 mois",
  common_dark_mode: "Mode sombre",
  common_light_mode: "Mode clair",

  // Language
  lang_en: "Anglais",
  lang_fr: "Français",
  lang_switch: "Langue",

  // 404
  notfound_title: "Page non trouvée",
  notfound_desc: "La page que vous recherchez n'existe pas ou a été déplacée.",
  notfound_back_home: "Retour à l'accueil",
  notfound_back_login: "Retour à la connexion",

  // Dashboard additional
  dash_good_morning: "Bonjour",
  dash_good_afternoon: "Bon après-midi",
  dash_good_evening: "Bonsoir",
  dash_avg_across_districts: "moyenne tous districts",
  dash_vs_last_week: "vs. semaine dernière",
  dash_live_badge: "En direct",
  dash_yaounde_central: "Yaoundé Central",
  dash_2wk_horizon: "2 sem",
  dash_all_filters: "Tout",
  dash_alert_filter: "Alerte",
  dash_prediction_filter: "Prédiction",
  dash_resource_filter: "Ressource",

  // Alerts additional
  alerts_recommended_action: "Action recommandée",
  alerts_risk: "Risque",
  alerts_predicted: "Prévu",
  alerts_growth: "Croissance",
  alerts_cases: "Cas",
  alerts_status_label: "Statut",
  alerts_try_adjusting: "Essayez d'ajuster vos critères de filtre",

  // Predictions additional
  pred_chart_subtitle: "Cas historiques vs prévisions IA avec intervalle de confiance à 95%",
  pred_legend_historical: "Historique",
  pred_legend_predicted: "Prévu",
  pred_legend_confidence: "Confiance",
  pred_prediction_start: "Début prévision",
  pred_select_district: "Sélectionnez un district pour voir l'importance des caractéristiques",
  pred_population: "Population",
  pred_density: "Densité",
  pred_coordinates: "Coordonnées",
  pred_region_label: "Région",

  // Resources additional
  res_actions: "Actions",
  res_edit_resource: "Modifier la ressource",
  res_delete_confirm_title: "Supprimer la ressource ?",
  res_delete_confirm_desc: "Cette action est irréversible. La ressource sera définitivement supprimée de l'inventaire.",
  res_showing: "Affichage de {{count}} sur {{total}} ressources",
  res_unit_label: "Unité",
  res_min_threshold_label: "Seuil minimum",
  res_predicted_demand_label: "Demande prévue",

  // Organizations additional
  org_active_org: "Organisation active",
  org_type: "Type",
  org_region: "Région",
  org_users_short: "Utilisateurs",
  org_resources_short: "Ressources",
  org_active_suffix: "actifs",
  org_team_members: "Membres de l'équipe",
  org_invite_user: "Inviter un utilisateur",
  org_activity_logs: "Journaux d'activité",
  org_user_header: "Utilisateur",
  org_role_header: "Rôle",
  org_status_header: "Statut",
  org_last_active_header: "Dernier actif",
  org_actions_header: "Actions",
  org_invite_title: "Inviter un membre d'équipe",
  org_full_name: "Nom complet",
  org_send_invitation: "Envoyer l'invitation",
  org_no_logs: "Aucun journal d'activité pour cette organisation.",
  org_role_desc_viewer: "Les observateurs ne peuvent que lire les données. Les utilisateurs d'org gèrent les ressources. Les agents de santé ont un accès complet. Les admins gèrent les utilisateurs.",

  // Settings additional
  settings_threshold_config_title: "Configuration des seuils d'alerte",
  settings_growth_threshold: "Seuil de taux de croissance (%)",
  settings_below_threshold: "Seuil inférieur (%)",
  settings_viz_normal: "Normal",
  settings_viz_medium: "Moyen",
  settings_viz_high: "Élevé",
  settings_key_created: "Créée",
  settings_key_last_used: "Dernier usage",
  settings_key_status: "Statut",
  settings_new_api_key: "Nouvelle clé API",
  settings_never: "Jamais",
  settings_healthy: "Sain",
  settings_last_incident_desc: "Dégradation du service cartographique",
  settings_days_ago: "jours",
  settings_role_desc_health_officer: "Accès complet à toutes les fonctionnalités",
  settings_role_desc_org_user: "Ressources org + prédictions partagées",
  settings_role_desc_admin: "Gestion utilisateurs + paramètres système",
  settings_role_desc_viewer: "Tableau de bord + alertes en lecture seule",

  // Reports additional
  reports_national_confirmed_8wk: "Cas confirmés nationaux — 8 dernières semaines",
  reports_outbreak_metrics: "Métriques d'épidémie",
  reports_active_interventions_metric: "Interventions actives",
  reports_pop_covered_metric: "Population couverte",
  reports_outbreaks_prevented: "Épidémies évitées (Est.)",
  reports_rdt_prepositioned: "Kits TDR pré-positionnés",
  reports_llin_distributed: "Moustiquaires distribuées",
  reports_risk_by_region: "Risque par région",
  reports_actions: "Actions",
  reports_view_predictions: "Voir les prédictions",
  reports_view_alerts: "Voir les alertes",
  reports_ok: "OK",
  reports_showing_districts: "Affichage de {{count}} sur {{total}} districts",
  reports_clear_region: "Effacer le filtre de région",

  // Login additional
  auth_signin_desc: "Connectez-vous pour accéder à la plateforme de prédiction des épidémies de paludisme",

  // Signup
  auth_request_access_title: "Demander l'accès",
  auth_request_desc: "Demandez l'accès à la plateforme de prédiction des épidémies de paludisme MalariaGuard",
  auth_full_name: "Nom complet",
  auth_organization: "Organisation",
  auth_requested_role: "Rôle demandé",
  auth_region_district: "Région / District",
  auth_select_region: "Sélectionnez votre région",
  auth_reason_access: "Raison de l'accès",
  auth_reason_placeholder: "Décrivez votre rôle et pourquoi vous avez besoin d'accéder à la plateforme...",
  auth_submit_request: "Soumettre la demande",
  auth_submitting: "Envoi en cours...",
  auth_request_submitted: "Demande soumise",
  auth_request_submitted_desc: "Votre demande d'accès a été envoyée à l'administrateur de la plateforme.",
  auth_redirecting: "Redirection vers la connexion...",
  auth_already_have_access: "Vous avez déjà accès ? Se connecter",
  auth_char_count: "({{count}}/500)",

  // Landing additional
  landing_hero_badge: "Prédiction d'épidémie par IA",
  landing_trusted_by: "Approuvé par",
  landing_preview_title: "Le centre de contrôle",
  landing_preview_desc: "Un tableau de bord unifiant les prédictions, alertes, ressources et données météo.",
  landing_most_popular: "Le plus populaire",
  landing_footer_moh: "Ministère de la Santé Publique, Cameroun",
  landing_footer_built: "Construit avec l'IA pour l'Afrique",

  // Sidebar
  sidebar_collapse: "Réduire",
  sidebar_expand: "Développer",

  // Topbar
  topbar_platform: "Plateforme EpiSense",
  topbar_mark_all_read: "Tout marquer comme lu",
};